import { getLegalDocUrl } from "@/utils/legalDocs"

type LegalLocale = "fr" | "nl" | "en"

const DEFAULT_PRIVACY_LINKS: Record<LegalLocale, string> = {
    fr: "https://www.travelski.com/instit/donnees-personnelles",
    nl: "https://www.nl.travelski.com/instit-privacy-verklaring",
    en: "https://www.uk.travelski.com/instit-privacy-policy",
}

const DEFAULT_DATA_RIGHTS_LINKS: Record<LegalLocale, string> = {
    fr: "https://datalegaldrive.com/ed/exercer/formulaire_exercice/travelski/fr/1",
    nl: "https://datalegaldrive.com/ed/exercer/formulaire_exercice/travelski/nl",
    en: "https://datalegaldrive.com/ed/exercer/formulaire_exercice/travelski/en",
}

const YOONLY_PRIVACY_LINKS: Record<any, string> = {
    "www.befr.yoonly.eu": "https://www.yoonly.eu/be-fr/donnees-personnelles/",
    "www.benl.yoonly.eu": "https://www.yoonly.eu/be-nl/privacy-policy/",
    "www.nl.yoonly.eu": "https://www.yoonly.eu/nl-nl/privacy-policy/",
}
const YOONLY_DATA_RIGHTS_LINKS: Record<any, string> = {
    "www.befr.yoonly.eu": "https://datalegaldrive.com/ed/exercer/formulaire_exercice/yoonly",
    "www.benl.yoonly.eu": "https://datalegaldrive.com/ed/exercer/formulaire_exercice/yoonly/nl",
    "www.nl.yoonly.eu": "https://datalegaldrive.com/ed/exercer/formulaire_exercice/yoonly/nl",
}


const normalizeLocale = (locale?: string): LegalLocale => {
    if (!locale) return "fr"
    const normalized = locale.toLowerCase()
    if (normalized.startsWith("nl")) return "nl"
    if (normalized.startsWith("en") || normalized.startsWith("uk")) return "en"
    return "fr"
}

const getHostname = (): string | null => {
    return process.env.VUE_APP_WEBSITE || (window.location.hostname == 'localhost' ? 'www.travelski.com' : window.location.hostname)
}

export const isYoonlyHost = (hostname: string | null): boolean => {
    if (!hostname) return false
    return hostname.includes("yoonly")
}

export const getCgvLink = (): string => getLegalDocUrl("CGV")

export const getPrivacyPolicyLink = (locale?: string): string => {
    const hostname = getHostname()
    if (isYoonlyHost(hostname)) {
        return YOONLY_PRIVACY_LINKS[hostname]
    }
    return DEFAULT_PRIVACY_LINKS[normalizeLocale(locale)]
}

export const getDataRightsLink = (locale?: string): string => {
    const hostname = getHostname()
    if (isYoonlyHost(hostname)) {
        return YOONLY_DATA_RIGHTS_LINKS[hostname]
    }
    return DEFAULT_DATA_RIGHTS_LINKS[normalizeLocale(locale)]
}

